import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationStart, ParamMap, Router, Event } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AnalyticsService, AuthenticationService, CustomerService, DataService, LoansService, OperationsService, OptionsserviceService, StorageService } from 'src/app/_services';
import { ProductsService } from 'src/app/_services/products.service';
import { ShareddataserviceService } from 'src/app/_services/shareddataservice.service';
import { SummaryService } from 'src/app/_services/summary.service';
@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.css']
})
export class SummaryComponent implements OnInit, OnDestroy {
  
  @ViewChild('fileInput') fileInput: ElementRef;
  requests: any = [];
  ecosystems: Array<any> = [];
  sheets: Array<any> = [];
  sheetData: Array<any> = [];
  loading = false;
  throttle = 300;
  scrollDistance = 1;
  scrollUpDistance = 2;
  currentUser: any;
  drawer: boolean = false;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  croppingImage = false;
  states: any;
  is_multiple = false;
  show_cards = false;
  page: number = 1;
  start: number = 0;
  table: string = ''
  operator: string = '';
  currentEcosystemId: number;
  currentSheetId: number;
  loadingSidebar: boolean = false;
  loadingEcosystem: boolean = false;
  data: any = null
  editableFields: Array<any> = [];
  headerses: Array<any> = [];
  currentRoute: string = '';
  newColumn: Array<any> = [];
  newRecord = null;

  constructor(
    public toastr: ToastrService,
    public storageService: StorageService,
    public analyticsService: AnalyticsService,
    public optionsService: OptionsserviceService,
    public loansService: LoansService,
    private router: Router,
    private dataService: DataService,
    private authService: AuthenticationService,
    private customerService: CustomerService,
    private route: ActivatedRoute,
    private operationsService: OperationsService,
    private productService: ProductsService,
    private http: HttpClient,
    private _sharedDataService: ShareddataserviceService,
    private _summaryService: SummaryService
  ) { 

    this.currentUser = this.storageService.read<any>('currentUser');
    this.dataService.loadRequests.subscribe(res => { });

    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        const operator = event.url.split("/")[2]
        this.getEcosystem(this.page, this.start, operator)
      }
      // if (event instanceof NavigationEnd) {
      //     this.currentRoute = event.url;
      // }
    });
  }

  ngOnInit() {
    this.setOperator()
    this.getEcosystem(this.page, this.start, this.operator)
  }

  getEcosystem(page, start, operator) {
    this.loading = true;
    this.loadingSidebar = true;
    this.loadingEcosystem = true;
    this._summaryService.getEcosystem(page, start, operator).subscribe(result => {
      if (result.status) {
        this.loading = false;
        this.loadingSidebar = false;
        this.loadingEcosystem = false;
        this.ecosystems = result.data.ecosystem;
        this.sheets = result.data.sheets;
        this.sheetData = result.data.sheetData.data;
        this.headerses = result.data.sheetData.headers;
        this.editableFields = result.data.sheetData.editable;
        this.table = this.sheets[0].sheet_name;
        this.setActiveState(this.ecosystems[0].id, this.sheets[0].sheet_id);
      } else {
        this.loading = false;
        this.loadingSidebar = false;
        this.loadingEcosystem = false
        this.toastr.error('unable to fetch data', 'Error')
      }
    });
  }

  setOperator() {
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.operator = params.get('user');
    });
  }




  async changeEcosystem(ecosystem) {
    this.loadingSidebar = true;
    this.loading = true;
    try {
      this.sheets = await this.getSheet(ecosystem);
      this.sheetData = await this.getSheetData(this.sheets[0]);
      this.setActiveState(ecosystem.id, this.sheets[0].sheet_id);
      this.table = this.sheets[0].sheet_name
      this.loadingSidebar = false;
      this.loading = false;
    } catch (error) {
      this.loadingSidebar = false;
      this.loading = false;
      this.toastr.error('unable to fetch data', 'Error')
    }
  }

  async loadSheetData(sheet) {
    this.loading = true;
    try {
      this.sheetData = await this.getSheetData(sheet)
      this.loading = false;
      this.table = sheet.sheet_name;
      this.setActiveState(this.currentEcosystemId, sheet.sheet_id);
    } catch (error) {
      this.loading = false;
      this.toastr.error('unable to fetch data', 'Error')
    }

  }

  async getSheet(ecosystem) {
    const res = await this._summaryService.getSheet(ecosystem.id).toPromise();
    return res.data.sheets
  }

  async getSheetData(sheet) {
    const res = await this._summaryService.getSheetData(sheet.sheet_id).toPromise()
    this.editableFields = res.data.sheetData.editable
    this.headerses = res.data.sheetData.headers;

    return res.data.sheetData.data
  }

  setActiveState(ecosystemId, sheetId) {
    this.currentEcosystemId = ecosystemId;
    this.currentSheetId = sheetId;
  }

  

  closeDrawer() {
    this.data = null
    this.drawer = false;
  }

  loadEditData(request) {
    this.data = request
    this.drawer = true;
  }

  loadFirstData(request) {
    console.log(request)
    this.newRecord = Object.keys(request).reduce((accumulator, key) => { return { ...accumulator, [key]: null } }, {});
    this.newColumn = Object.entries(request).map(([key, value]) => key)
    console.log(this.newRecord)
    this.drawer = true;
  }

  async updateData(payload) {
    this._summaryService.EditData(this.currentSheetId, payload, this.data.id).subscribe(data=>{
      console.log(data);
      
    })
  }
  async createNewRow(payload) {
    console.log(payload)
  }

  // ngOnChanges() {
  //   this.getEcosystem(this.page, this.start, this.operator)
  // }



  ngOnDestroy(): void {
    console.log('ngOnDestroy');
  }

}
